Drupal.behaviors.sw_section_img_text_slider = {
  attach: function( context, settings ) {

    $('.img-text-slider').once('sw_section_img_text_slider').each(function() {
      let $wrap = $(this);
      let $slider = $wrap.find('.img-text-slider__slider');
      $slider.slick({
        arrows: true,
        fade: false,
        dots: false,
        adaptiveHeight: false,
        infinite: true,
        centerMode: true,
        //slidesToShow: 1,
        waitForAnimate: false,
      });

    });

  }
};
